import { ReactComponent as Circle } from "../assets/analyse/Circle.svg";
import { ReactComponent as Globe } from "../assets/analyse/globe.svg";
import { ReactComponent as Europe } from "../assets/analyse/europe.svg";
import ReactCountryFlag from "react-country-flag";
import { Tooltip, TooltipProps, tooltipClasses } from "@mui/material";
import { styled } from "@mui/material/styles";

import { ReactComponent as HEcoA } from "../assets/ecoscore/eco_h_a.svg";
import { ReactComponent as HEcoB } from "../assets/ecoscore/eco_h_b.svg";
import { ReactComponent as HEcoC } from "../assets/ecoscore/eco_h_c.svg";
import { ReactComponent as HEcoD } from "../assets/ecoscore/eco_h_d.svg";
import { ReactComponent as HEcoE } from "../assets/ecoscore/eco_h_e.svg";

export const getFormatedValue = (value) => {
  if (value < 0.001) {
    // return parseFloat(value).toExponential(1)
    return parseFloat(value).toFixed(2);
  } else if (value > 1000) {
    // return parseFloat(value).toExponential(1)
    return parseFloat(value).toFixed(2);
  } else {
    // return parseFloat(value).toFixed(2)
    return parseFloat(value).toFixed(2);
  }
};

export function isValidEmail(email) {
  return /\S+@\S+\.\S+/.test(email);
}

export const get_eco_score_icon = (eco_score) => {
  switch (true) {
    case eco_score >= 80:
      return <HEcoA className="h-10 w-24" />;
    case eco_score <= 80 && eco_score >= 60:
      return <HEcoB className="h-10 w-24" />;
    case eco_score <= 60 && eco_score >= 40:
      return <HEcoC className="h-10 w-24" />;
    case eco_score <= 40 && eco_score >= 20:
      return <HEcoD className="h-10 w-24" />;
    case eco_score <= 20:
      return <HEcoE className="h-10 w-24" />;
    default:
      return;
  }
};

export const convert_eco_value_to_letter = (eco_score) => {
  switch (true) {
    case eco_score >= 80:
      return "A";
    case eco_score <= 80 && eco_score >= 60:
      return "B";
    case eco_score <= 60 && eco_score >= 40:
      return "C";
    case eco_score <= 40 && eco_score >= 20:
      return "D";
    case eco_score <= 20:
      return "E";
    default:
      return;
  }
};

export const renderFlag = ({ item }) => {
  switch (item.value) {
    case "RoW":
      return (
        <div className="flex items-center">
          <Globe height={20} width={20} className={"pr-[2px]"} />
          {item.label}
        </div>
      );

    case "GLO":
      return (
        <div className="flex items-center">
          <Globe height={20} width={20} className={"pr-[2px]"} />
          {item.label}
        </div>
      );

    case "RER":
      return (
        <div className="flex items-center">
          <Europe height={20} width={16} className={"mr-[3px]"} />
          {item.label}
        </div>
      );

    case "NAN":
      return (
        <div className="flex items-center">
          <Circle height={20} width={16} className={"mr-[3px]"} />
          {item.label}
        </div>
      );

    case "INDEF":
      return (
        <div className="flex items-center">
          <Circle height={20} width={16} className={"mr-[3px]"} />
          {item.label}
        </div>
      );

    default:
      return (
        <div className="flex">
          <div className="relative left-0 mr-[5px] flex items-center">
            <ReactCountryFlag countryCode={item.value} svg />
          </div>
          {item.label}
        </div>
      );
  }
};

export const getTypeParameterText = (K_type) => {
  switch (K_type) {
    case "K_Transports":
      return "Quantité";

    case "K_Energies":
      return "Quantité";

    case "K_Wastes":
      return "Quantité";

    case "K_Packaging":
      return "Quantité";

    default:
      return "Quantité";
  }
};

export const get_loss_data = (loss, raw_to_cooked) => {
  const sales_loss = loss.sales_loss ? loss.sales_loss : 0;
  const com_loss = loss.com_loss ? loss.com_loss : 0;
  const raw_to_cookd = raw_to_cooked === 1 ? 100 : raw_to_cooked === 0 ? 100 : raw_to_cooked * 100;
  return [sales_loss, com_loss, raw_to_cookd];
};

export const get_total_loss = (loss, raw_to_cooked) => {
  const [sales_loss, com_loss, raw_to_cookd] = get_loss_data(loss, raw_to_cooked);
  const total_loss = 1 / (1 - sales_loss / 100) / (1 - com_loss / 100) / (raw_to_cookd / 100);
  return total_loss;
};

export function StrSplit(text) {
  const newText = text.split("\n");
  return newText;
}

export const NoMaxWidthTooltip = styled(({ className, ...props }: TooltipProps) => <Tooltip {...props} classes={{ popper: className }} />)({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: "none",
  },
});

export const get_transport_country = (current) => {
  if (current.description.includes("Transport for")) {
    const country = current.description.split(" for ")[1].split(" ")[0];
    return country;
  } else {
    return "NAN";
  }
};

export const calculImpactStepResult = (analysis_data, indicator_id, step_index) => {
  //////////// get receip impact
  // res var
  // let indicator_unit;o
  const receip_impact = analysis_data.ingredients
    ? Object.entries(analysis_data.ingredients).reduce((accumulator, currentValue) => {
        // get ingredient transport_data
        var transport_impact = 0;
        // is not K_cooking...
        if (!currentValue[1].name) {
          const transports_data = Object.values(currentValue[1]).find((x) => x.category.name === "K_Transports");
          if (transports_data) {
            const transports_data_inputs = Object.values(transports_data.inputs).filter((x) => x.flow.category.name === "K_Transports");
            transport_impact =  Object.values(transports_data_inputs).reduce((acc, crr) => {
              const indicator = crr.flow.flow_impact_factors.find((i) => i.id === indicator_id);
              const indicator_coefficient = indicator ? indicator.coefficient : 0;
              const amount = crr.amount;
              const conversion_factor = crr.unit.conversion_factor;
              return acc + indicator_coefficient * amount * conversion_factor;
            }, 0);

            ///////// get ingredient impact
            const ingredient_lca = Object.values(Object.values(analysis_data.lca.lca_steps).slice(-1)[0].inputs).find((x) => x.id === currentValue[0]);
            const indicator = ingredient_lca.flow.flow_impact_factors.find((i) => i.id === indicator_id);
            const indicator_coefficient = indicator ? indicator.coefficient : 0;
            const amount = ingredient_lca.amount;
            const conversion_factor = ingredient_lca.unit.conversion_factor;
            transport_impact = transport_impact + indicator_coefficient * amount * conversion_factor;
          }
        } else {
          // look for receip process as a flow
          const ingredient_lca = Object.values(Object.values(analysis_data.lca.lca_steps).slice(-1)[0].inputs).find((x) => x.id === currentValue[0]);
          const indicator = ingredient_lca.flow.flow_impact_factors.find((i) => i.id === indicator_id);
          const indicator_coefficient = indicator ? indicator.coefficient : 0;
          const amount = ingredient_lca.amount;
          const conversion_factor = ingredient_lca.unit.conversion_factor;
          transport_impact += indicator_coefficient * amount * conversion_factor;
        }
        return accumulator + transport_impact;
      }, 0)
    : Object.values(analysis_data.lca.lca_steps)[4].outputs[0].flow.flow_impact_factors.find((x) => x.id === indicator_id).coefficient;

  //////////// get other steps impact
  const inputs = Object.values(analysis_data.lca.lca_steps).filter((x) => x.step_index <= step_index && x.step_index > 2);
  let other_steps_score = 0;
  inputs.forEach((input) => {
    const intermediate_score = input.inputs
      ? Object.values(input.inputs).reduce((accumulator, currentValue) => {
          const flow_impact = currentValue.flow.flow_impact_factors.find((i) => i.id === indicator_id).coefficient;
          const to_return = accumulator + currentValue.amount * currentValue.unit.conversion_factor * flow_impact;
          return to_return;
        }, 0)
      : 0;

    other_steps_score = other_steps_score + intermediate_score;
  });

  /////////// get wastes/ food given waste
  inputs.forEach((input) => {
    const intermediate_score = input.outputs
      ? Object.values(input.outputs).reduce((accumulator, currentValue) => {
          if (currentValue.flow && (currentValue.flow.category.name === "K_Wastes" || currentValue.flow.category.name === "K_Food_Given")) {
            const flow_impact = currentValue.flow.flow_impact_factors.find((i) => i.id === indicator_id).coefficient;
            const to_return = accumulator + currentValue.amount * currentValue.unit.conversion_factor * flow_impact;
            return to_return;
          } else {
            return 0;
          }
        }, 0)
      : 0;

    other_steps_score = other_steps_score + intermediate_score;
  });

  return parseFloat(other_steps_score + receip_impact);
};

export const calculImpactStepResultOpt = (analysis_data, indicator_id, step_index) => {
  //////////// get receip impact
  const receip_impact = analysis_data.ingredients
    ? Object.entries(analysis_data.ingredients).reduce((accumulator, currentValue) => {
        // get ingredient transport_data
        var transport_impact = 0;
        // is not K_cooking...
        if (!currentValue[1].name) {
          const transports_data = Object.values(currentValue[1]).find((x) => x.category.name === "K_Transports");
          if (transports_data && transports_data.inputs) {
            const opt_inputs = Object.values(transports_data.inputs).filter((x) => x.optimization_results);
            transport_impact =
              transport_impact +
              Object.values(opt_inputs).reduce((accumulator, currentValue) => {
                const indicator = currentValue.optimization_results.flow.flow_impact_factors.find((i) => i.id === indicator_id);
                const indicator_coefficient = indicator ? indicator.coefficient : 0;
                const amount = currentValue.optimization_results.amount;
                const conversion_factor = currentValue.optimization_results.unit.conversion_factor;
                return accumulator + indicator_coefficient * amount * conversion_factor;
              }, 0);
            const nomal_inputs = Object.values(transports_data.inputs).filter((x) => !x.optimization_results);
            const transports_data_inputs = Object.values(nomal_inputs).filter((x) => x.flow.category.name === "K_Transports");
            transport_impact =
              transport_impact +
              Object.values(transports_data_inputs).reduce((accumulator, currentValue) => {
                const indicator = currentValue.flow.flow_impact_factors.find((i) => i.id === indicator_id);
                const indicator_coefficient = indicator ? indicator.coefficient : 0;
                const amount = currentValue.amount;
                const conversion_factor = currentValue.unit.conversion_factor;
                return accumulator + indicator_coefficient * amount * conversion_factor;
              }, 0);
          }
          // ///////// get ingredient impact
          const ingredient_lca = Object.values(Object.values(analysis_data.lca.lca_steps).slice(-1)[0].inputs).find((x) => x.id === currentValue[0]);
          const indicator = ingredient_lca.flow.flow_impact_factors.find((i) => i.id === indicator_id);
          const indicator_coefficient = indicator ? indicator.coefficient : 0;
          const amount = ingredient_lca.amount;
          const conversion_factor = ingredient_lca.unit.conversion_factor;
          transport_impact = transport_impact + indicator_coefficient * amount * conversion_factor;
        } else {
          // look for receip process as a flow
          // const ingredient_lca = Object.values(Object.values(analysis_data.lca.lca_steps).slice(-1)[0].inputs).find((x) => x.id === currentValue[1].id);
          const ingredient_lca = Object.values(Object.values(analysis_data.lca.lca_steps).slice(-1)[0].inputs).find((x) => x.id === currentValue[0]);
          const indicator = ingredient_lca.flow.flow_impact_factors.find((i) => i.id === indicator_id);
          const indicator_coefficient = indicator ? indicator.coefficient : 0;
          // indicator_unit = indicator.unit;
          const amount = ingredient_lca.amount;
          const conversion_factor = ingredient_lca.unit.conversion_factor;
          transport_impact = indicator_coefficient * amount * conversion_factor;
        }
        return accumulator + transport_impact;
      }, 0)
    : Object.values(analysis_data.lca.lca_steps)[4].outputs[0].flow.flow_impact_factors.find((x) => x.id === indicator_id).coefficient;

  ////////// get other steps impact
  const inputs = Object.values(analysis_data.lca.lca_steps).filter((x) => x.step_index <= step_index && x.step_index > 2);
  let other_steps_score = 0;
  inputs.forEach((input) => {
    const intermediate_score = input.inputs
      ? Object.values(input.inputs).reduce((accumulator, currentValue) => {
          let to_return;
          if (currentValue.custom_analysis) {
            const flow_impact = currentValue.optimization_results.flow.flow_impact_factors.find((i) => i.id === indicator_id).coefficient;
            to_return = accumulator + currentValue.optimization_results.amount * currentValue.optimization_results.unit.conversion_factor * flow_impact;
          } else {
            const flow_impact = currentValue.flow.flow_impact_factors.find((i) => i.id === indicator_id).coefficient;
            to_return = accumulator + currentValue.amount * currentValue.unit.conversion_factor * flow_impact;
          }
          return to_return;
        }, 0)
      : 0;

    other_steps_score = other_steps_score + intermediate_score;
  });

  inputs.forEach((input) => {
    const intermediate_score = input.outputs
      ? Object.values(input.outputs).reduce((accumulator, currentValue) => {
          let to_return;
          if (currentValue.custom_analysis) {
            if (
              currentValue.optimization_results.flow &&
              (currentValue.optimization_results.flow.category.name === "K_Wastes" || currentValue.optimization_results.flow.category.name === "K_Food_Given")
            ) {
              const flow_impact = currentValue.optimization_results.flow.flow_impact_factors.find((i) => i.id === indicator_id).coefficient;
              to_return = accumulator + currentValue.optimization_results.amount * currentValue.optimization_results.unit.conversion_factor * flow_impact;
            }
          } else {
            if (currentValue.flow && (currentValue.flow.category.name === "K_Wastes" || currentValue.flow.category.name === "K_Food_Given")) {
              const flow_impact = currentValue.flow.flow_impact_factors.find((i) => i.id === indicator_id).coefficient;
              to_return = accumulator + currentValue.amount * currentValue.unit.conversion_factor * flow_impact;
            }
          }
          return to_return;
        }, 0)
      : 0;

    other_steps_score = other_steps_score + intermediate_score;
  });

  return parseFloat(other_steps_score + receip_impact);

  // return 11
};

export const calculStepResultQuantity = (analysis_data, step_index) => {
  // loop thourhg previous steps
  let quantity_sum = 0;
  for (let i = 6 - step_index; i <= 4; i++) {
    if (analysis_data.lca) {
      if (Object.values(analysis_data.lca.lca_steps)[i].inputs) {
        Object.values(Object.values(analysis_data.lca.lca_steps)[i].inputs).map((x) => {
          // if is K_Ingredients, or K_Packaging
          if (x.flow && (x.flow.category.name === "K_Ingredients" || x.flow.category.name == "K_Packaging")) {
            quantity_sum = parseFloat(quantity_sum) + parseFloat(x.amount ? x.amount : 0);
          }
          // if is K_waste, K_Food_Given, Remove
          if (x.flow && (x.flow.category.name === "K_Wastes" || x.flow.category.name == "K_Food_Given")) {
            quantity_sum = parseFloat(quantity_sum) - parseFloat(x.amount ? x.amount : 0);
          }
          // if is packaging and optimization
          if (x.optimization_results && x.optimization_results.flow.category.name == "K_Packaging") {
            quantity_sum = parseFloat(quantity_sum) + parseFloat(x.optimization_results.amount ? x.optimization_results.amount : 0);
          }
        });
      } else if (Object.values(analysis_data.lca.lca_steps)[i].outputs && step_index === 2) {
        quantity_sum = parseFloat(quantity_sum) + parseFloat(Object.values(analysis_data.lca.lca_steps)[i].outputs[0].amount);
      }
      if (Object.values(analysis_data.lca.lca_steps)[i].outputs) {
        Object.values(Object.values(analysis_data.lca.lca_steps)[i].outputs).map((x) => {
          if (x.flow && (x.flow.category.name === "K_Wastes" || x.flow.category.name == "K_Food_Given")) {
            quantity_sum = parseFloat(quantity_sum) - parseFloat(x.amount ? x.amount : 0);
          }
        });
      }
    }
  }
  return parseFloat(quantity_sum).toFixed(2);
};

export function imageScale(view, image) {
  let width;
  let height;
  if (image.height > image.width) {
    height = view.height;
    width = (image.width * height) / image.height;
  } else {
    width = view.width;
    height = (image.height * width) / image.width;
  }
  let x = view.width / 2 - width / 2;
  let y = 0;
  return { width: width, height: height, x, y: y };
}

export function findInputError(errors, name) {
  const filtered = Object.keys(errors)
    .filter((key) => key.includes(name))
    .reduce((cur, key) => {
      return Object.assign(cur, { error: errors[key] });
    }, {});
  return filtered;
}

export const isFormInvalid = (err) => {
  if (Object.keys(err).length > 0) return true;
  return false;
};


